import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { api } from "@/lib/backend";
import { extractionWrapper } from "@/lib/backend/utils/extract";

export const queryOptions_signed_key_user = (params: Parameters<typeof api.file.getUserUrl>) =>
  queryOptions({
    queryKey: ["file", ...params] as const,
    queryFn: () => extractionWrapper(api.file.getUserUrl(...params)),
    staleTime: 1000 * 60 * 5, // 5 minutes
    placeholderData: keepPreviousData,
  });

export const queryOptions_signed_key_public = (params: Parameters<typeof api.file.getPublicUrl>) =>
  queryOptions({
    queryKey: ["file", params] as const,
    queryFn: () => extractionWrapper(api.file.getPublicUrl(...params)),
    staleTime: 1000 * 60 * 5, // 5 minutes
    placeholderData: keepPreviousData,
  });

export const queryOptions_signed_key_public_by_slug = (
  params: Parameters<typeof api.file.getPublicUrlBySlug>,
) =>
  queryOptions({
    queryKey: ["file", params] as const,
    queryFn: () => extractionWrapper(api.file.getPublicUrlBySlug(...params)),
    staleTime: 1000 * 60 * 5, // 5 minutes
    placeholderData: keepPreviousData,
  });

export const queryOptions_signed_key_project = (
  params: Parameters<typeof api.file.getProjectUrl>,
) =>
  queryOptions({
    queryKey: ["file", ...params] as const,
    queryFn: () => extractionWrapper(api.file.getProjectUrl(...params)),
    staleTime: 1000 * 60 * 5, // 5 minutes
    placeholderData: keepPreviousData,
  });

export const queryOptions_signed_key_relation = (
  params: Parameters<typeof api.file.getRelationUrl>,
) =>
  queryOptions({
    queryKey: ["file", ...params] as const,
    queryFn: () => extractionWrapper(api.file.getRelationUrl(...params)),
    staleTime: 1000 * 60 * 5, // 5 minutes
    placeholderData: keepPreviousData,
  });

export const queryOptions_signed_key_me = (params: Parameters<typeof api.file.getMeUrl>) =>
  queryOptions({
    queryKey: ["file", ...params] as const,
    queryFn: () => extractionWrapper(api.file.getMeUrl(...params)),
    staleTime: 1000 * 60 * 5, // 5 minutes
    placeholderData: keepPreviousData,
  });

export type SignedKeyQueryOptions =
  | typeof queryOptions_signed_key_user
  | typeof queryOptions_signed_key_public
  | typeof queryOptions_signed_key_project
  | typeof queryOptions_signed_key_me
  | typeof queryOptions_signed_key_relation;
